import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { ReactNode, useRef, useState, useImperativeHandle, forwardRef } from 'react';
import styles from './toast.less';


export interface Notice {
  key: UKey;
  type: string;
  content: ReactNode;
  onClose?: (key: UKey) => void;
}

export interface ActiveNotice extends Omit<Notice, 'key'> {
  key?: UKey;
  duration?: number;
  close?: () => void;
}

export type AddNoticeFunc = (notice: ActiveNotice) => ActiveNotice

const ToastBox = forwardRef<{ addNotice: AddNoticeFunc }>((_, ref) => {
  const { current: _this } = useRef<{ notices: Notice[] }>({ notices: [] });
  const [list, setList] = useState<Notice[]>([]);

  useImperativeHandle(ref, () => ({ addNotice }));

  const getNoticeKey = () => {
    return `notice-${new Date().getTime()}-${_this.notices.length}`
  };

  const addNotice: AddNoticeFunc = notice => {
    notice.key = getNoticeKey();
    _this.notices.push(notice as Notice);
    if (notice.duration > 0) {
      setTimeout(() => {
        removeNotice(notice.key);
      }, notice.duration)
    }
    setList([..._this.notices]);
    return {
      ...notice,
      close: () => removeNotice(notice.key)
    };
  };

  const removeNotice = (key: Notice['key']) => {
    _this.notices = _this.notices.filter((notice) => {
      if (notice.key === key) {
        if (notice.onClose) {
          setTimeout(() => notice.onClose(key), 300);
        }
        return false;
      }
      return true;
    });
    setList(_this.notices);
  };

  return (
    <div className={classNames(styles.mask, { [styles.hidden]: list.length === 0 })}>
      {list.map(notice => (
        <div className={classNames(styles.toast, styles[notice.type])} key={notice.key}>
          {notice.content}
        </div>
      ))}
    </div>
  );
});

export interface Notification {
  addNotice: AddNoticeFunc;
  destory: () => void;
}

export default function createNotification(): Notification {
  let notification: { addNotice: AddNoticeFunc };
  const div = document.createElement('div');
  document.body.appendChild(div);
  ReactDOM.render(<ToastBox ref={ref => notification = ref} />, div);
  return {
    addNotice(notice: ActiveNotice) {
      return notification.addNotice(notice);
    },
    destory() {
      ReactDOM.unmountComponentAtNode(div);
      document.body.removeChild(div);
    }
  }
}
